import {handleAPI, API_VERSION_ONE_ADMIN} from '../../../utils/apiUtils';
const parent = 'SETTING_'
export function insurancesLoad(filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurances`;
  const method = 'GET'

  return {
    type: `${parent}INSURANCES_LOAD`,
    payload: handleAPI(url, filters, method)
  };
}

export function insuranceLoad(id, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurances/${id}`;
  const method = 'GET'

  return {
    type: `${parent}INSURANCE_LOAD`,
    payload: handleAPI(url,filters,method)
  };
}

export function insuranceCreate(data, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurances`;
  const method= 'POST'
  return {
    type: `${parent}INSURANCE_CREATE`,
    payload: handleAPI(url,filters,method, {insurance: {...data}})
  }
}

export function insuranceUpdate(data, filters){
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurances/${data.id}`;
  const method = "PUT"
  return {
    type: `${parent}INSURANCE_UPDATE`,
    payload: handleAPI(url,filters,method, {insurance: {...data}})
  }
}

export function insuranceDelete(id, filters) {
  const url = `/${API_VERSION_ONE_ADMIN}/settings/insurances/${id}`;
  const method = 'DELETE';

  return {
    type: `${parent}INSURANCE_DELETE`,
    payload: new Promise((resolve, reject) => {
      handleAPI(url, filters, method)
        .then(response => {
          resolve({ id: id, ...response });
        })
        .catch(err => {
          reject(err);
        });
    })
  };
}

export function insuranceEdit(id, insuranceType) {
  return {
    type: `${parent}INSURANCE_EDIT`,
    id,
    insuranceType,
  };
}

export function insuranceEditCancel() {
  return {
    type: `${parent}INSURANCE_EDIT_CANCEL`
  };
}
